import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';

export class IdeaCategories extends Field {
  static subqueriesForModel() {
    return { ideaCategories: ['name'] };
  }

  get title() {
    return 'Idea categories';
  }

  exampleContents(): FieldContentsData {
    return {
      tags: [
        { name: 'enhancement', color: '#666666' },
        { name: 'quality of life', color: '#666666' },
      ],
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.ideaCategories?.length) {
      return {
        tags: record.ideaCategories.map(({ name }) => {
          return {
            name,
            color: '#666666',
          };
        }),
      };
    }

    return {};
  }
}
